module.exports = __webpack_public_path__ + "img/16.26b9b685.png";